import Vue from 'vue'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { APP_VERSION } from './constants'
import OAuthClient from "@/helpers/oauth";
import { get } from 'lodash'

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_BUGSNAG_KEY) {
    Bugsnag.start({
        apiKey: process.env.VUE_APP_BUGSNAG_KEY,
        releaseStage: process.env.VUE_APP_ENVIRONMENT,
        appVersion: APP_VERSION,

        onError: function (event) {
            const token = OAuthClient.getToken()
            event.setUser(get(token, 'id', 'none'))
            event.addMetadata('aInfo', {
                exp: get(token, 'exp', 'none'),
                iat: get(token, 'iat', 'none'),
            })
        },

        plugins: [new BugsnagPluginVue()]
    })
    const bugsnagVue = Bugsnag.getPlugin('vue')
    bugsnagVue.installVueErrorHandler(Vue)
}
